module.exports = __webpack_public_path__ + "static/AngioScore2-2005c41d9513b04059aeb0735d5f0df4.png";